// Composables

import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/TopN',
  },
  {
    path: '/service',
    redirect: '/service/TopN',
  },
  {
    path: '/TopN',
    component: () => import(/* webpackChunkName: "TopN" */ '@components/TopN/contents/TopN.vue'),
  },
  {
    path: '/service/TopN',
    component: () => import(/* webpackChunkName: "TopN" */ '@components/TopN/contents/TopN.vue'),
  },
  {
    name: 'TopNWithRoute',
    path: '/TopN/:country/:area/:category',
    component: () => import(/* webpackChunkName: "TopNWithRoute" */ '@components/TopN/contents/TopN.vue'),
  },
  {
    name: 'TopNWithRouteService',
    path: '/service/TopN/:country/:area/:category',
    component: () => import(/* webpackChunkName: "TopNWithRoute" */ '@components/TopN/contents/TopN.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
